import { render, staticRenderFns } from "./detailShippingCompany.vue?vue&type=template&id=1de2e09a&"
import script from "./detailShippingCompany.vue?vue&type=script&lang=js&"
export * from "./detailShippingCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports